import { useGetLabelsQuery } from 'features/metadata/metadata';
import { useActiveOrganisation } from 'hooks/useActiveOrganisation';
import { useMemo } from 'react';
import { createSelector } from '@reduxjs/toolkit';

const emptyArray = [];

export function useGetLabels(folder) {
    const activeOrganisation = useActiveOrganisation();

    const filterLabels = useMemo(() => {
        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (res) => res.data,
            (_data, folder) => folder,
            (data, folder) => {
                if (!data) {
                    return emptyArray;
                }

                if (folder) {
                    return data.filter((label) => label.folder === folder);
                }

                return data;
            },
        );
    }, []);

    const { organisationLabels } = useGetLabelsQuery(
        { organisationId: activeOrganisation },
        {
            selectFromResult: (result) => ({
                organisationLabels: filterLabels(result, folder),
            }),
        },
    );

    return organisationLabels;
}
